import { CONSTANTS } from '../attributes/BatteryAlerts';
import FilterTranslatorConverter from '../../attributes/filters/FilterTranslatorConverter';
const filterTranslator = {
  [CONSTANTS.END_OF_LIFE]: () => {
    const endOfLifeLimitTimestamp = Date.now() - CONSTANTS.END_OF_LIFE_REPORTING_THRESHOLD;
    return {
      type: 'comparison',
      field: 'data/lastHeartbeat',
      comparator: '<',
      value: endOfLifeLimitTimestamp,
      isDate: true
    };
  },
  [CONSTANTS.LOW_VOLTAGE]: () => {
    return {
      type: 'comparison',
      field: 'data/batteryVoltage',
      comparator: '<=',
      value: CONSTANTS.LOW_VOLTAGE_THRESHOLD
    };
  },
  [CONSTANTS.LOW_BATTERY]: () => {
    return {
      type: 'comparison',
      field: 'data/batteryLevel',
      comparator: '<=',
      value: CONSTANTS.LOW_BATTERY_THRESHOLD
    };
  }
};
export default FilterTranslatorConverter.create('locator.batteryAlerts', filterTranslator);